import { IS_BROWSER } from "@smartrr/shared/constants";
import { getParsedQuery } from "@smartrr/shared/utils/frontendQueryUtils";

export const isInIFrame = !!(IS_BROWSER && window?.parent?.location !== window?.location);

const parsedQuery = getParsedQuery();

export const isInShopifyIframe: boolean =
  isInIFrame && !!parsedQuery.shop && !!parsedQuery.hmac && !!parsedQuery.timestamp;
